import { render, staticRenderFns } from "./U_DataBusiness.vue?vue&type=template&id=28b3332e&scoped=true&"
import script from "./U_DataBusiness.vue?vue&type=script&lang=js&"
export * from "./U_DataBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b3332e",
  null
  
)

export default component.exports